import ImageTextEditor from '@intercom/embercom-composer/components/image-text-editor';
export default ImageTextEditor;
